/**
 * @generated SignedSource<<b9a1b3be3d8ec4c983e48ab86fec7854>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MusicPieceStatus = "COMPLETE" | "ERRORED" | "PROCESSING" | "UPLOADING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type LibraryDetailBody_piece$data = {
  readonly id: string;
  readonly name: string | null;
  readonly status: MusicPieceStatus;
  readonly " $fragmentType": "LibraryDetailBody_piece";
};
export type LibraryDetailBody_piece$key = {
  readonly " $data"?: LibraryDetailBody_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"LibraryDetailBody_piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LibraryDetailBody_piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "eb45c3b485cfad54e74736a9fac31570";

export default node;
